import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import countriesReducer from './countriesSlice';

export default configureStore({
  reducer: {
    auth: authReducer,
    countries: countriesReducer,
  },
});
